import { render } from "./SharingSummaryForRecipient.vue?vue&type=template&id=fe921570"
import script from "./SharingSummaryForRecipient.vue?vue&type=script&lang=js"
export * from "./SharingSummaryForRecipient.vue?vue&type=script&lang=js"

import "./SharingSummaryForRecipient.vue?vue&type=style&index=0&id=fe921570&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__